import { useQuery } from "@tanstack/react-query";
import { dashboards } from "./query";
import { IMemberWidgetSchema } from "./types";

export function GetMemberWidgets(model: IMemberWidgetSchema) {
  return useQuery({
    ...dashboards.getMemberWidgets(model),
    enabled: model?.filterOptions !== undefined,
  });
}

export function GetVisitorWidgets() {
  return useQuery(dashboards.getVisitorWidgets());
}

export function GetMaterialWidgets() {
  return useQuery(dashboards.getMaterialWidgets());
}

export function GetCirculationWidgets() {
  return useQuery(dashboards.getCirculationWidgets());
}
